import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Permissions reducer is used to track which screens & actions that
// the logged in user should be allowed to see

export interface PermissionsReducer {
  cinder: Record<string, boolean>
  glance: Record<string, boolean>
  keystone: Record<string, boolean>
  neutron: Record<string, boolean>
  nova: Record<string, boolean>
  // False until the first updatePermissions() of a session, so route guards can tell
  // "permissions not fetched yet" apart from "fetched, and the user has none".
  loaded: boolean
}

export const defaultState: PermissionsReducer = {
  cinder: {},
  glance: {},
  keystone: {},
  neutron: {},
  nova: {},
  loaded: false,
}

type UpdateAction = Partial<PermissionsReducer>

const {
  name: permissionsKey,
  reducer: permissionsReducer,
  actions: permissionsActions,
} = createSlice({
  name: 'permissions',
  initialState: defaultState,
  reducers: {
    updatePermissions: (state, { payload }: PayloadAction<UpdateAction>) => {
      // Replace state wholesale (defaults + payload) so a service key omitted from
      // payload is reset rather than retaining a stale value from a previous session.
      return { ...defaultState, ...payload, loaded: true }
    },
    clearPermissions: () => {
      return defaultState
    },
  },
})

export { permissionsActions, permissionsKey }
export default permissionsReducer
